import React, { useState, useEffect, FC } from "react"
import { Link } from "gatsby"
import { rhythm } from "../../utils/typography"

interface Props {
  location: string
  title: string
  children: object
}

const Layout: FC<Props> = props => {
  const hasValidLocalStorage =
    typeof window !== "undefined"
      ? localStorage.getItem("theme") === "dark"
        ? true
        : false
      : false
  const [checked, setChecked] = useState(hasValidLocalStorage)

  useEffect(() => {
    document
      .getElementsByTagName("HTML")[0]
      .setAttribute("data-theme", localStorage.getItem("theme"))
  }, [checked])

  const toggleThemeChange = () => {
    if (checked === false) {
      localStorage.setItem("theme", "dark")
      setChecked(true)
    } else {
      localStorage.setItem("theme", "light")
      setChecked(false)
    }
  }
  const { location, title, children } = props
  // const rootPath = `${__PATH_PREFIX__}/`

  const renderHeader = () => {
    return (
      <h3
        style={{
          fontFamily: `Montserrat, sans-serif`,
          marginTop: 0,
        }}
      >
        <Link
          style={{
            boxShadow: `none`,
            textDecoration: `none`,
            color: `inherit`,
          }}
          to={`/`}
        >
          {title}
        </Link>
      </h3>
    )
  }

  return (
    <div
      style={{
        marginLeft: `auto`,
        marginRight: `auto`,
        maxWidth: rhythm(24),
        padding: `${rhythm(1.5)} ${rhythm(3 / 4)}`,
        color: checked ? `#fff` : `#282c34`,
      }}
    >
      <header
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginBottom: "2.625rem",
        }}
      >
        {renderHeader()}
        <div style={{ display: "flex", justifyContent: "center " }}>
          <div style={{ paddingRight: "10px", paddingTop: "3px" }}>
            Dark Mode
          </div>
          <label className="switch">
            <input
              type="checkbox"
              defaultChecked={checked}
              onChange={() => toggleThemeChange()}
            />
            <span className="slider round" />
          </label>
        </div>
      </header>
      <main>{children}</main>
      <footer>
        © {new Date().getFullYear()}
        {` `}
        <a href="https://www.thejohnyu.com">thejohnyu.com</a>
      </footer>
    </div>
  )
}

export default Layout
